import React, { useContext, useEffect, useState } from 'react'
import { AuthContext } from '@dataplace.ai/features'
import { IChildrenProps } from '@dataplace.ai/types'
import { LoadingPage } from '@dataplace.ai/ui-components/pages'
import { checkMigrationAndRedirect } from 'apps/placeme/src/features/ChooseLocationReport/chooseLocationSlice'
import { useAppDispatch } from 'apps/placeme/src/redux/hooks'

export const HasToBeNotMigratedBootstrap = ({ children }: IChildrenProps): JSX.Element => {
  const authContext = useContext(AuthContext)
  const dispatch = useAppDispatch()
  const [lastCompletedMigrationCheckUserId, setLastCompletedMigrationCheckUserId] = useState('')

  const userId = authContext.userData.user?.uid ?? ''
  const isUserLoaded = authContext.userData.userLoaded
  const shouldCheckMigration = isUserLoaded
    && !!authContext.userData.user?.emailVerified
    && userId.length > 0
  const shouldWaitForMigrationCheck = shouldCheckMigration
    && lastCompletedMigrationCheckUserId !== userId

  useEffect(() => {
    let isCancelled = false

    const runMigrationCheck = async (): Promise<void> => {
      if (!shouldCheckMigration || lastCompletedMigrationCheckUserId === userId) {
        return
      }

      try {
        await dispatch(checkMigrationAndRedirect(userId))
      } finally {
        if (!isCancelled) {
          setLastCompletedMigrationCheckUserId(userId)
        }
      }
    }

    runMigrationCheck()

    return () => {
      isCancelled = true
    }
  }, [
    dispatch,
    lastCompletedMigrationCheckUserId,
    shouldCheckMigration,
    userId,
  ])

  if (!isUserLoaded || shouldWaitForMigrationCheck) {
    return <LoadingPage product='placeme' />
  }

  return <>{children}</>
}

export default HasToBeNotMigratedBootstrap
